module.exports = __webpack_public_path__ + "Server-Unavailable.AzureCloudService.b10f072205dc938d50abb046df51c125.hashedasset.svg";